import { useState } from 'react';
import { Button, Icon } from '@iwoca/orion';
import { useAmplitude } from 'hooks/useAmplitude';
import CopyToClipboard from 'react-copy-to-clipboard';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

type TProps = {
  customerEmail: string;
  customerFirstName: string;
  introducerFirstName: string;
  secondary?: boolean;
};

export const CopyLinkOpenBankingEmailButton = ({
  customerEmail,
  customerFirstName,
  introducerFirstName,
  secondary,
}: TProps) => {
  const [isCopyClicked, setIsCopyClicked] = useState(false);
  const { trackEvent } = useAmplitude();

  const hostname =
    getEnvironment() === 'production' ? 'iwoca.co.uk' : 'stage.iwoca-dev.co.uk';
  const url = `https://${hostname}/account/link-open-banking/`;

  const clipboardText = `Hi ${customerFirstName},

To complete your loan application, the lender we’ve approached, iwoca, needs you to link Open Banking to share your bank transactions.

Sign in to iwoca here: ${url}

To link your bank account, you’ll need to:
- Sign in to iwoca using ${customerEmail}
- Select “Link account” to connect via Open Banking

Applications with linked bank accounts receive a decision 2x faster on average

Open banking is a secure way to share your business banking data without sharing your password. You can find out more information about it at https://www.openbanking.org.uk/why-open-banking-is-safe/.

Any questions, let me know.

Many thanks,
${introducerFirstName}
`;

  return (
    <CopyToClipboard text={clipboardText} onCopy={() => setIsCopyClicked(true)}>
      <Button
        variant={secondary ? 'tertiary' : 'primary'}
        onClick={() =>
          trackEvent(AMPLITUDE_EVENTS.generateLinkOpenBankingEmailClicked)
        }
      >
        Copy email
        <Icon icon={isCopyClicked ? 'copyCheck' : 'copyOutline'} />
      </Button>
    </CopyToClipboard>
  );
};
